import { parse, unparse, download, RECORD_SEP, UNIT_SEP } from 'papaparse'
import { SharedVariable } from './../model/SharedVariable'
import { cid, container } from 'inversify-props'

export function downloadCSVFile<T> (column: string[], data: Array<T>, fileName: string) {
  const csvData = unparse({
    fields: column, // column names
    data: data
  }, {
    quotes: false
  })

  const blob = new Blob([csvData], { type: 'text/csv' })
  const filename = fileName
  download(blob, filename)
}

export function parseCsvFile (file, callBack) {
  parse(file, {
    header: true,
    complete: function (res) {
      const sharedVariable = container.get<SharedVariable>(cid.SharedVariable)
      const { uiService } = sharedVariable

      if (res.errors.length > 0) {
        let stringerror = 'The following errors were encountered.\n\n'
        res.errors.forEach((error, index) => {
          stringerror += 'Row ' + (index) + ': ' + error.message + '.\n'
        })
        uiService.alert.show({
          type: 'error',
          message: stringerror
        })
        return
      }
      const resArray = []
      // if no error
      res.data.forEach(rowData => {
        const parseObj = []
        Object.keys(rowData).forEach(key => {
          parseObj.push(rowData[key])
        })
        resArray.push(parseObj)
      })
      callBack(resArray)
    },
    error: undefined,
    skipEmptyLines: 'greedy',
    transform: undefined,
    delimitersToGuess: [',', 't', '|', ';', RECORD_SEP, UNIT_SEP]
  })
}
